/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  button: {
    display: "block",
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    width: "60%",
    margin: "auto"
  }
});

class AlternativesSelect extends React.Component {
  state = {
    alternative: 0,
    open: false
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.changeAlternative(event.target.value);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes } = this.props;

    return (
      this.props.alternatives.length > 1 && (
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="demo-controlled-open-select">
            Alternatives
          </InputLabel>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.alternative}
            onChange={this.handleChange}
            inputProps={{
              name: "alternative",
              id: "demo-controlled-open-select"
            }}
          >
            {this.props.alternatives.map((alternative, index) => {
              return (
                <MenuItem key={index} value={index}>
                  Alternative {index + 1}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )
    );
  }
}

AlternativesSelect.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AlternativesSelect);
